import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@material-ui/core';

interface ApproveProductionDialogProps {
    open: boolean;
    onClose: () => void;
    onApprove: () => void;
}

const ApproveProductionDialog = ({ open, onClose, onApprove }: ApproveProductionDialogProps) =>

    <Dialog open={open} onClose={onClose}>
        <DialogTitle>
            <span style={{ fontSize: '18px', fontWeight: '700' }}>
                Approve for Production
            </span>
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                Are you sure you want to approve this case for production?
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose} color="primary">
                Cancel
            </Button>
            <Button onClick={onApprove} color="primary" variant="contained">
                Approve
            </Button>
        </DialogActions>
    </Dialog>



export default ApproveProductionDialog; 